import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

export default function Pagination({ currentPage, totalPages, setCurrentPage }) {
  const pages = [];

  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="rn-pagination text-center">
      <ul className="page-list">
        {currentPage > 1 && (
          <li>
            <Link to="#" onClick={() => handleClick(currentPage - 1)}>
              <FaAngleLeft />
            </Link>
          </li>
        )}
        {pages.map((page) => (
          <li key={page} className={page === currentPage ? 'active' : ''}>
            <Link to="#" onClick={() => handleClick(page)}>
              {page}
            </Link>
          </li>
        ))}
        {currentPage < totalPages && (
          <li>
            <Link to="#" onClick={() => handleClick(currentPage + 1)}>
              <FaAngleRight />
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}
